import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { correctClasses } from '../../common/config'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { RadioInput, Checkbox, LessonMediaContent } from '../components'

class OptionsTest extends React.Component {
  componentDidMount() {
    const { lesson, initAnswers, showResult } = this.props
    if (lesson && lesson.wordbox && !showResult) {
      const optionsAnswers = lesson.options.questions.map(q => (
        { userAnswer: [], correctAnswers: q.correctAnswers }
      ))
      initAnswers(lesson.id, optionsAnswers)
    }
  }

  checkAnswers() {
    const { lesson, setResult, answers } = this.props
    let points = 0

    answers.forEach(a => {
      let countSimiliarities = 0
      for (let i = 0; i < a.userAnswer.length; i += 1) {
        if (a.correctAnswers.indexOf(a.userAnswer[i]) !== -1) {
          countSimiliarities += 1
        }
      }

      if (countSimiliarities === a.correctAnswers.length &&
        countSimiliarities === a.userAnswer.length) {
        a.correct = 2
        a.points = 1
      } else {
        a.correct = 0
        a.points = 0
      }
      points += a.points
    })
    setResult({ id: lesson.id, answers, points })
  }

  render() {
    const { lesson, updateAnswers, showResult, answers,
      points, maxPoints, intl, lessonOrder } = this.props

    if (!answers || !answers.length) return null
    const { questions } = lesson.options

    return (
      <div className="options-item item-box column-direction">
        <p className="instructions">
          {lessonOrder}. {lesson.instructions || intl.formatMessage(messages.chooseCorrect)}
        </p>
        <LessonMediaContent lesson={lesson} />
        <div className="width-full">
          {
            questions.map((q, qid) => (
              <div
                key={`${q.text}${qid}`}
                className={`question-item width-full column-direction item-box ${showResult && correctClasses[answers[qid].correct]}`}
              >
                <div className="question-text-box in-test width-full">
                  <p>{q.text}</p>
                </div>
                <div className="question-answers">
                  {
                    q.answers.map((ans, aid) => (
                      <div key={`${qid}${ans}${aid}`}>
                        {
                          lesson.options.onlyOneCorrect ?
                            <RadioInput
                              id={`${qid}${ans}${aid}`}
                              disabled={showResult}
                              checked={answers[qid].userAnswer.includes(aid)}
                              onChange={() => {
                                if (answers[qid].userAnswer.includes(aid)) {
                                  updateAnswers(lesson.id, qid,
                                    answers[qid].userAnswer.filter(a => a !== aid))
                                } else {
                                  let newAnswers = [aid]
                                  if (!lesson.options.onlyOneCorrect) {
                                    newAnswers = [...answers[qid].userAnswer, aid]
                                  }
                                  updateAnswers(lesson.id, qid, newAnswers)
                                }
                              }}
                              label={ans}
                            />
                          :
                            <Checkbox
                              id={`${qid}${ans}${aid}`}
                              disabled={showResult}
                              checked={answers[qid].userAnswer.includes(aid)}
                              onChange={() => {
                                if (answers[qid].userAnswer.includes(aid)) {
                                  updateAnswers(lesson.id, qid,
                                    answers[qid].userAnswer.filter(a => a !== aid))
                                } else {
                                  let newAnswers = [aid]
                                  if (!lesson.options.onlyOneCorrect) {
                                    newAnswers = [...answers[qid].userAnswer, aid]
                                  }
                                  updateAnswers(lesson.id, qid, newAnswers)
                                }
                              }}
                              label={ans}
                            />
                        }
                        {/* <label htmlFor={`${qid}${ans}${aid}`}>{ans}</label> */}
                      </div>
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
        {
          showResult &&
          <p className="lesson-result">
            {intl.formatMessage(messages.points)}: {points}/{maxPoints}
          </p>
        }
      </div>
    )
  }
}

OptionsTest.defaultProps = {
  lesson: null,
  showResult: false,
  initAnswers: null,
  updateAnswers: null,
  setResult: null,
  points: 0,
  maxPoints: 0,
  lessonOrder: 0,
  answers: [],
}

OptionsTest.propTypes = {
  intl: PropTypes.object.isRequired,
  showResult: PropTypes.bool,
  lesson: PropTypes.object,
  points: PropTypes.number,
  maxPoints: PropTypes.number,
  lessonOrder: PropTypes.number,
  answers: PropTypes.array,
  initAnswers: PropTypes.func,
  updateAnswers: PropTypes.func,
  setResult: PropTypes.func,
}

const enhance = compose(
  connect(state => ({
    exam: state.tests.exam,
  }), { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)


export default enhance(OptionsTest)

const messages = defineMessages({
  chooseCorrect: {
    id: 'optionsTest.chooseCorrect',
    defaultMessage: 'Vyberte správnu odpoveď.',
  },
  points: {
    id: 'optionsTest.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/OptionsTest.js